import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBookmark12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconBookmark12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m6 7.832.615.48L10 10.952V1.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v9.452l3.385-2.64zM6 9.1l3.385 2.64A1 1 0 0 0 11 10.952V1.5A1.5 1.5 0 0 0 9.5 0h-7A1.5 1.5 0 0 0 1 1.5v9.452a1 1 0 0 0 1.615.788z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBookmark12);
